// 🎨 Couleurs du site (charte Acadeclic) : planning, créneaux, réservation, « Passer en ligne ? »,
// « Mes cours ». Les e-mails de l'API utilisent les mêmes (acadeclic-api, services/EmailLayout.js).
export const BRAND = {
  black: "#1e1e1e",
  grey: "#2d2d2d",
  blue: "#076f7e",
  orange: "#f99308",
  lightBlue: "#a5daed",
};

// Teintes dérivées (fonds légers, traits)
export const TINTS = {
  orangeHover: "#e48600",
  orangeDisabled: "#f9c27a",
  orangeSoft: "rgba(249, 147, 8, 0.12)",
  blueSoft: "rgba(165, 218, 237, 0.35)",
  line: "rgba(30, 30, 30, 0.10)",
  lineDark: "rgba(255, 255, 255, 0.12)",
  muted: "#5f6368",
  mutedDark: "#b8bec5",
};
